import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import LinkWithSearchParam from './LinkWithSearchParam';

const getQueryName = entity => {
  if (entity === 'article') return 'getPublishedArticle';
  if (entity === 'broker') return 'getPublishedBroker';
  if (entity === 'exhibitor') return 'getPublishedExhibitor';
  if (entity === 'page') return 'getPublishedPage';
  if (entity === 'podcast') return 'getPublishedPodcast';
  if (entity === 'profile') return 'getPublishedProfile';
  if (entity === 'yacht_for_charter') return 'getPublishedYachtForCharter';
  if (entity === 'yacht_for_sale') return 'getPublishedYachtForSale';
  if (entity === 'yacht_page') return 'getPublishedYachtPage';

  return 'getPublishedArticle';
};

const getEntityId = (
  entity,
  {
    articleId,
    title,
    brokerId,
    exhibitorId,
    pageId,
    podcastId,
    profileId,
    yachtPageId,
    yachtForCharterId,
    yachtForSaleId
  }
) => {
  if (entity === 'article') return articleId;
  if (entity === 'broker') return brokerId;
  if (entity === 'exhibitor') return exhibitorId;
  if (entity === 'page') return pageId;
  if (entity === 'podcast') return podcastId;
  if (entity === 'profile') return profileId;
  if (entity === 'yacht_for_charter') return yachtPageId;
  if (entity === 'yacht_for_sale') return yachtForCharterId;
  if (entity === 'yacht_page') return yachtForSaleId;

  return null;
};

const YachtSearchLink = ({
  parent,
  entity,
  prefix,
  title,
  articleId,
  brokerId,
  exhibitorId,
  pageId,
  podcastId,
  profileId,
  yachtPageId,
  yachtForCharterId,
  yachtForSaleId
}) => {
  const entityId = getEntityId(entity, {
    articleId,
    brokerId,
    exhibitorId,
    pageId,
    podcastId,
    profileId,
    yachtPageId,
    yachtForCharterId,
    yachtForSaleId
  });
  if (!entityId) return null;

  const { data, error, loading } = useQuery(
    gql`
    query getEntityData($id: String!){
      entityData: ${getQueryName(entity)}(id: $id){
        name,
        url,
        id,
        __typename
      }
    }
  `,
    {
      variables: { id: entityId }
    }
  );

  if (loading) return 'loading...';
  if (error) return error.message;
  if (!data || !data.entityData) return null;

  return (
    <div className="bi-card-block__yacht-search-link-wrapper">
      <LinkWithSearchParam
        href={data.entityData.url}
        parent={parent}
        text={title || data.entityData.name}
      />
    </div>
  );
};

YachtSearchLink.propTypes = {
  parent: PropTypes.object.isRequired,
  entity: PropTypes.string.isRequired,
  title: PropTypes.string,
  articleId: PropTypes.string,
  brokerId: PropTypes.string,
  exhibitorId: PropTypes.string,
  pageId: PropTypes.string,
  podcastId: PropTypes.string,
  profileId: PropTypes.string,
  yachtPageId: PropTypes.string,
  yachtForCharterId: PropTypes.string,
  yachtForSaleId: PropTypes.string
};

export default YachtSearchLink;
